import { ILeftItem } from "../../../ts/interface/user";

export const left: ILeftItem[] = [
  {
    text: 'Find friends',
    img: 'friends',
    to: "/friends"
  },
  {
    text: 'Memories',
    img: 'memories',
    to: 'memories'
  },
  {
    text: 'Groups',
    img: 'groups',
    notification: '5 new',
    to: '/groups'

  },
  {
    text: 'Marketplace',
    img: 'marketplace',
    to: '/marketplace'
  },
  {
    text: 'Watch',
    img: 'watch',
    notification: '9 new videos',
    to: '/watch'

  },
  {
    text: 'Saved',
    img: 'saved',
    to: '/saved'
  },
  {
    text: 'Pages',
    img: 'pages',
    to: '/pages'
  },
  {
    text: 'Events',
    img: 'events',
    to: '/events'

  },
  {
    text: 'Ad Center',
    img: 'ad'
  },
  {
    text: 'Ads Manager',
    img: 'ads'
  },
  {
    text: 'Campus',
    img: 'campus'
  },
  {
    text: 'Climate science center',
    img: 'climate'
  },
  {
    text: 'Community Help',
    img: 'community'
  },
  {
    text: 'COVID-19 Information Centrer',
    img: 'covid'
  },
  {
    text: 'Emotional health',
    img: 'emotional'
  },
  {
    text: 'Devbook Pay',
    img: 'pay'
  },
  {
    text: 'Favorites',
    img: 'fav'
  },
  {
    text: 'Fundraisers',
    img: 'fund'
  },
  {
    text: 'Gaming Video',
    img: 'gaming'
  },
  {
    text: 'Jobs',
    img: 'jobs'
  },
  {
    text: 'Live videos',
    img: 'live'
  },
  {
    text: 'Messenger',
    img: 'messenger'
  },
  {
    text: 'Messenger Kids',
    img: 'messkids'
  },
  {
    text: 'Most recent',
    img: 'recent'
  },
  {
    text: 'Play Games',
    img: 'play'
  },
  {
    text: 'Recent ad activity',
    img: 'recentad'
  },
  {
    text: 'Weather',
    img: 'weather'
  }
];
